
import { useEffect, useState } from 'react';
import { useAuth } from '@/context/auth';
import { useSmsStatus } from '@/context/SmsStatusContext';

export function useSmsBilling() {
  const { user } = useAuth();
  const { 
    organisationSmsStatus,
    checkOrganisationSmsStatus
  } = useSmsStatus();
  
  const [smsEnabled, setSmsEnabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [usageData, setUsageData] = useState(null);
  
  useEffect(() => {
    const checkStatus = async () => {
      setLoading(true);
      setError(null);
      
      try {
        if (!user?.organisationId) {
          setSmsEnabled(false);
          return;
        }
        
        // Check if we already have the status in context
        if (organisationSmsStatus.has(user.organisationId)) {
          setSmsEnabled(organisationSmsStatus.get(user.organisationId) || false);
          return;
        }
        
        // Otherwise fetch it
        const enabled = await checkOrganisationSmsStatus(user.organisationId);
        setSmsEnabled(enabled);
      } catch (err) {
        console.error('Error checking SMS status:', err);
        setError('Failed to check SMS status');
        setSmsEnabled(false);
      } finally {
        setLoading(false);
      }
    };
    
    checkStatus();
  }, [user?.organisationId]);
  
  // Add mock refresh function to prevent errors
  const refreshData = () => {
    console.log('Refreshing SMS data...');
    // In a real implementation, this would refresh the data
  };
  
  return {
    smsEnabled,
    loading,
    error,
    usageData,
    refreshData
  };
}
